import { render, staticRenderFns } from "./LineBroadcastAccordion.vue?vue&type=template&id=47296aff&scoped=true&"
import script from "./LineBroadcastAccordion.vue?vue&type=script&lang=js&"
export * from "./LineBroadcastAccordion.vue?vue&type=script&lang=js&"
import style0 from "./LineBroadcastAccordion.vue?vue&type=style&index=0&id=47296aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47296aff",
  null
  
)

export default component.exports